import { useStore } from '@/store'
import { WelcomeScreen } from '@/components/WelcomeScreen'
import { ReadingCanvas } from '@/components/ReadingCanvas'
import { GazeHUD } from '@/components/GazeHUD'
import { CalibrationScreen } from '@/components/CalibrationScreen'
import { gazeTracker } from '@/lib/gaze-tracker'

export function App() {
  const mode = useStore((s) => s.mode)
  const setMode = useStore((s) => s.setMode)
  const setTrackingMode = useStore((s) => s.setTrackingMode)
  const setGazeState = useStore((s) => s.setGazeState)

  if (mode === 'welcome') {
    return <WelcomeScreen />
  }

  if (mode === 'calibrating') {
    return (
      <CalibrationScreen
        onComplete={() => {
          setMode('reading')
        }}
        onCancel={() => {
          // Fall back to mouse tracking
          gazeTracker.stop()
          gazeTracker.startMouse(() => {}) // gaze data flows via gazeBridge
          setTrackingMode('mouse')
          setMode('reading')
        }}
      />
    )
  }

  return (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      <ReadingCanvas />
      <GazeHUD />
    </div>
  )
}
